// Hindi (Hinglish) dictionary for vee-validate.
// Wired up in src/main.js via Validator.localize('hi', veeHi).
// Switches reactively in src/global_mixin.js on $root.selectedLanguage change.

export default {
  messages: {
    // Built-in rules actually used in the app:
    // required, email, max, max_value, min, min_value, numeric, decimal
    required:  (field)        => `${field} फ़ील्ड आवश्यक है`,
    email:     (field)        => `${field} एक मान्य ईमेल होना चाहिए`,
    max:       (field, [n])   => `${field} ${n} वर्ण से अधिक नहीं हो सकता`,
    min:       (field, [n])   => `${field} कम से कम ${n} वर्ण का होना चाहिए`,
    max_value: (field, [n])   => `${field} ${n} से अधिक नहीं हो सकता`,
    min_value: (field, [n])   => `${field} ${n} से कम नहीं हो सकता`,
    numeric:   (field)        => `${field} केवल अंक होने चाहिए`,
    decimal:   (field, [d])   => `${field} एक मान्य संख्या होनी चाहिए (अधिकतम ${d || ''} दशमलव)`.trim(),

    // Custom rules extended in components — keep messages here so the
    // hardcoded getMessage() in form.vue/transaction_mixin.js/etc. is overridden
    // by the dictionary (dictionary takes precedence when registered).
    nospace:           () => `स्पेस वर्ण की अनुमति नहीं है`,
    verify_pincode:    () => `पिनकोड मान्य नहीं है`,
    verify_gstnumber:  () => `GST नंबर मान्य नहीं है`,
    verify_pannumber:  () => `PAN नंबर मान्य नहीं है`,
    verify_hsn:        () => `HSN कोड मान्य नहीं है`,
  },

  // Field-name overrides — keys MUST match the `data-vv-as` value (or the
  // input's `name` attr when no data-vv-as is set).
  attributes: {
    // Identity / contact
    'name':                 'नाम',
    'display name':         'डिस्प्ले नाम',
    'business name':        'बिज़नेस नाम',
    'business owner name':  'बिज़नेस ओनर नाम',
    'mobile number':        'मोबाइल नंबर',
    'phone number':         'फ़ोन नंबर',
    'email':                'ईमेल',
    'address':              'पता',
    'state':                'राज्य',
    'otp':                  'OTP',

    // GST / tax IDs
    'GST number':                 'GST नंबर',
    'gst number':                 'GST नंबर',
    'GST registration status':    'GST पंजीकरण स्टेटस',
    'GST 2.0 Percentage':         'GST 2.0 प्रतिशत',
    'gst rate':                   'GST रेट',
    'tax (percentage)':           'टैक्स (प्रतिशत)',
    'cess (percentage)':          'उपकर (प्रतिशत)',
    'cess precentage':            'उपकर प्रतिशत',
    'cess 2.0 percentage':        'उपकर 2.0 प्रतिशत',
    'cess amount':                'उपकर अमाउंट',
    'cess value':                 'उपकर मूल्य',
    'hsn code':                   'HSN कोड',
    'export type':                'एक्सपोर्ट टाइप',

    // Ledger / accounts
    'account ledger':             'अकाउंट लेजर',
    'expense category':           'एक्सपेंस कैटेगरी',
    'expense ledger':             'एक्सपेंस लेजर',
    'on account':                 'ऑन अकाउंट',
    'new balance':                'नया बैलेंस',

    // Transaction
    'transaction type':           'ट्रांसेक्शन टाइप',
    'bill number':                'बिल नंबर',
    'next number':                'अगला नंबर',
    'prefix':                     'प्रीफ़िक्स',
    'amount':                     'अमाउंट',
    'round off':                  'राउंड ऑफ',
    'due days':                   'ड्यू दिन',
    'payment term':               'पेमेंट टर्म',
    'return qty':                 'रिटर्न क्वांटिटी',

    // Stock / inventory
    'Batch Number':               'बैच नंबर',
    'Low Stock Qty':              'लो स्टॉक क्वांटिटी',
    'quantity':                   'क्वांटिटी',
    'pack qty':                   'पैक क्वांटिटी',
    'secondary pack qty':         'सेकेंडरी पैक क्वांटिटी',
    'primary unit':               'प्राइमरी यूनिट',
    'unit quantity code':         'यूनिट क्वांटिटी कोड',
    'conversion rate':            'कन्वर्शन रेट',
    'from godown':                'फ्रॉम गोडाउन',
    'to godown':                  'टू गोडाउन',
    'purchase rate':              'परचेस रेट',
    'whole sale price':           'होलसेल प्राइस',

    // UPI / payment
    'UPI ID':                     'UPI ID',
    'UPI Name':                   'UPI नाम',

    // Barcode / print labels
    'billing label':              'बिलिंग लेबल',
    'shipping label':             'शिपिंग लेबल',
  },
}



// WEBPACK FOOTER //
// ./src/locales/vee_hi.js